module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_favorite_active-67d24c3fe694f6250a082eb707c44db5.svg";